import Vue from 'vue'

Vue.mixin({
  methods: {
    validateTimeFrame(bagId, timeFrame) {
      return new Promise((resolve, reject) => {
        let url = Routing.generate('api_validate_time_frame_bag', {
          id: bagId,
          timeFrame: timeFrame
        })

        this.$http.get(url).then(response => {
          resolve(response.data.isValid)

        }, response => {
          reject(this.handleAjaxError(response))
        })
      })
    }
  }
})
